import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";

import { AppsIosIdentifiersFilter } from "../../components/filters/AppsIdentifiersFilter/ios/AppsIosIdentifiersFilter";
import { AppsIosIdentifiersFilterResult } from "../../components/filters/AppsIdentifiersFilter/ios/AppsIosIdentifiersFilterResult";
import type { IAppsIosIdentifiersDescriptionDto } from "../../types/descriptionDto";
import { appsFilterCategoryMap } from "../../types/filterCategory";
import type { IAppsIosIdentifierFilter } from "../../types/iosFiltersDto";

const createIosIdentifierFilter = (iosIdentifiers: IAppsIosIdentifiersDescriptionDto): SearchFilterInstance => ({
    key: "identifier",
    trackingName: "App Identifier",
    apiCategory: "appsFilters",
    category: appsFilterCategoryMap.apps,
    title: { key: "si.find_apps.filters.identifier.title" },
    tooltipText: { key: "si.find_apps.filters.identifier.ios.tooltip" },
    filter: new FilterPanelBaseFilter<IAppsIosIdentifierFilter, IAppsIosIdentifiersDescriptionDto>({
        options: iosIdentifiers || {
            identifiers: ["bundleIds", "trackIds"],
        },
    }),
    filterView: AppsIosIdentifiersFilter,
    filterResultView: AppsIosIdentifiersFilterResult,
});

export default createIosIdentifierFilter;
